import { formatAmount } from '../../../utils/appointments/formatAmount';
import { MEMBERSHIP_TYPE } from '../../../constants/programs';

export function viewProgramCost({
  price,
  period,
  quantity,
  recurrenceType,
  formatMessage,
}) {
  const safePrice = parseFloat(price) || '';

  switch (recurrenceType) {
    case MEMBERSHIP_TYPE.ONE_TIME_PURCHASE: {
      // Never expires program
      if (!quantity && period && safePrice) {
        return `$${formatAmount(safePrice)}`;
      }
      // if there is 1 period then use singular form of period word
      if (quantity && period && safePrice) {
        return `$${formatAmount(safePrice)} ${formatMessage({
          id: 'common.for',
        })}${quantity === 1 ? ' ' : ` ${quantity} `}${period}`;
      }
      return '';
    }
    case MEMBERSHIP_TYPE.RECURRENT: {
      // if there is 1 period then use singular form of period word
      if (quantity && period && safePrice) {
        return `$${formatAmount(safePrice)}/${
          quantity === 1 ? '' : `${quantity} `
        }${period}`;
      }
      return '';
    }
    default:
      return '';
  }
}



// WEBPACK FOOTER //
// ./src/components/Programs/utils/viewProgramCost.js